import { AddCardFormModal } from 'features/add-card';
import { getDataAutoTestAttributes } from 'shared/lib/data-auto-test';
import { showSuccessToast } from 'shared/lib/notifications';
import { Button } from 'shared/ui/Button';
import { MaterialIcon } from 'shared/ui/MaterialIcon';
import { useModalsActions } from 'shared/ui/SideModal';
import classNames from 'classnames';

import type { OnboardingStatus } from '../../model';

import { BadgeIcon } from './BadgeIcon';

interface CreditCardCompletedProps {
  status: OnboardingStatus;
  refetchOnboarding: () => void;
}

export function CreditCardCompleted({ status, refetchOnboarding }: CreditCardCompletedProps) {
  const { open } = useModalsActions();
  const isNotDone = status !== 'done';
  const openAddCardModal = () =>
    open(
      <AddCardFormModal
        onAdded={() => {
          showSuccessToast('Your credit card was successfully added.');
          refetchOnboarding();
        }}
      />
    );

  return (
    <div
      className={classNames(
        ' flex w-[536px] px-[25px] pb-[13px] pt-4 border-b',
        isNotDone ? 'shadow-lg shadow-card-step border-transparent' : ' border-slate-100'
      )}
    >
      <div className="mr-[85px] flex items-center gap-2">
        <MaterialIcon className="text-base text-slate-900">add_card</MaterialIcon>
        <span className="text-sm text-slate-900">Credit Card</span>
      </div>
      <BadgeIcon
        status={status}
        tooltipText={isNotDone ? 'Please add Credit Card' : undefined}
      />
      <div className="ml-auto flex w-[149px] justify-center">
        {isNotDone ? (
          <Button
            iconLeftName="add_circle_outline"
            className="w-[149px]"
            variant="primary"
            size="small"
            onClick={openAddCardModal}
            {...getDataAutoTestAttributes(['button-add-card'])}
          >
            Add credit card
          </Button>
        ) : (
          <MaterialIcon className="text-[20px] text-deep-green-700">check</MaterialIcon>
        )}
      </div>
    </div>
  );
}
